import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CustomImage, CustomModal } from '@src/components';
import digitalCardIncentiveImage from '@src/assets/images/cardOrders/digital-cart-incentive.png';
import digitalCardIncentiveCloseIcon from '@src/assets/images/cardOrders/digital-cart-incentive-close-icon.png';
import digitalCardIncentiveBtn from '@src/assets/images/cardOrders/digital-cart-incentive-btn.png';
import '../../../../styles/cardOrder/digitalCardIncentive.scss';
import PropTypes from 'prop-types';
import {dataLayer} from '@src/utils/utils';
import {setCardOrderPopupDigital} from '@src/store/slice/cardOrderSlice';



const DigitalCardIncentive = ({ digitalModalVisible, setDigitalModalVisible, isModalClosed , setIsModalClosed }) => {
    const dispatch = useDispatch();

    const DigitalHandleClose = useCallback(
        () => {
            setDigitalModalVisible(false);
        },
        [digitalModalVisible]
    );


     const digitalHandleCloseIconClick = () => {
        dataLayer("digital_kart_popup","closed","");
        dispatch(setCardOrderPopupDigital(false));
        setDigitalModalVisible(false);
        setIsModalClosed(true);
    };

    const digitalHandleBtnClick = () => {
        dataLayer("digital_kart_popup","Dijital Kart","Digital Kart Seçin");
        dispatch(setCardOrderPopupDigital(true));
        setDigitalModalVisible(false);
        setIsModalClosed(false);
    };

    return (
        <CustomModal
            visible={digitalModalVisible}
            maskClosable={false}
            footer={false}
            onCancel={DigitalHandleClose}
            className='digital-card-incentive'
            isModalClosed={isModalClosed}
            closeIcon={
                <CustomImage
                    className="digital-card-incentive-close"
                    src={digitalCardIncentiveCloseIcon}
                    alt="Close"
                    onClick={digitalHandleCloseIconClick}
                />
            }
        >
            <CustomImage className="digital-card-incentive-image" src={digitalCardIncentiveImage} />
            <CustomImage className="digital-card-incentive-btn" src={digitalCardIncentiveBtn} onClick={digitalHandleBtnClick} />
        </CustomModal>
    );
};

DigitalCardIncentive.propTypes = {
    digitalModalVisible: PropTypes.bool.isRequired,
    setDigitalModalVisible: PropTypes.func.isRequired,
    isModalClosed: PropTypes.bool.isRequired,
    setIsModalClosed: PropTypes.func.isRequired,
};


export default DigitalCardIncentive;
